import { useEffect, useState } from "react";

/**
 * Wall-clock time for the device status and menu bars, refreshed every 30s.
 * Starts null so the first paint never shows a stale or mismatched time.
 */
export function useClock(): Date | null {
    const [now, setNow] = useState<Date | null>(null);
    useEffect(() => {
        setNow(new Date());
        const id = window.setInterval(() => setNow(new Date()), 30_000);
        return () => window.clearInterval(id);
    }, []);
    return now;
}
